import { useEffect } from 'react'

/**
 * Client-side redirect for legacy marketing routes whose content moved to the
 * B2B subdomains (`/sistema-arenas` → arenas.meiucaapp.com.br, etc.).
 *
 * Serves users following old links immediately; the SEO-grade 301 lives at the
 * CDN layer (CloudFront) and is tracked as an infra task.
 */
export function ExternalRedirectPage({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to)
  }, [to])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-8 h-8 border-4 border-brand-primary border-t-transparent rounded-full animate-spin" />
    </div>
  )
}
